import React, { createContext, useContext } from "react";
import { useAuth } from "./AuthContext";
import useMeetingHook from "../hooks/useMeeting";

const MeetingContext = createContext(null);

export const useMeeting = () => {
  const context = useContext(MeetingContext);
  if (!context) {
    throw new Error("useMeeting must be used within a MeetingProvider");
  }
  return context;
};

export const MeetingProvider = ({ children }) => {
  const { user } = useAuth();
  const meeting = useMeetingHook(user);

  return (
    <MeetingContext.Provider value={meeting}>
      {children}
    </MeetingContext.Provider>
  );
};
